import React, { memo, useState, useEffect } from 'react';

function StarterPackOffer({ onPurchase, onDismiss }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`starter-pack-offer${visible ? ' starter-pack-visible' : ''}`}>
      <div className="starter-pack-header">
        <span className="starter-pack-badge">SPECIAL OFFER</span>
        <button className="starter-pack-close" onClick={onDismiss} aria-label="Dismiss">
          &#10005;
        </button>
      </div>
      <h3 className="starter-pack-title">Starter Pack</h3>
      <div className="starter-pack-contents">
        <div className="starter-pack-item">
          <span className="starter-pack-item-icon">&#8634;</span>
          <span>5 Undos</span>
        </div>
        <div className="starter-pack-item">
          <span className="starter-pack-item-icon">&#128163;</span>
          <span>5 Bombs</span>
        </div>
        <div className="starter-pack-item">
          <span className="starter-pack-item-icon">&#127912;</span>
          <span>Neon Theme</span>
        </div>
      </div>
      <button className="starter-pack-buy" onClick={onPurchase}>
        Get for $0.99
      </button>
    </div>
  );
}

export default memo(StarterPackOffer);
